import React, { useState } from 'react';
import blurTop from '../../assets/splashScreen/Blur.svg'
import kyc from '../../assets/splashScreen/Group 714.svg'
import { useNavigate } from 'react-router-dom';
// Mock asset for the decorative background blur

/**
 * KYCVerificationForm Component
 * Renders the Know Your Customer verification form with inputs for profile data.
 */
export default function KYCVerificationForm() {
    const navigate  = useNavigate()
  const [formData, setFormData] = useState({
    fullName: 'Luc',
    dateOfBirth: '1990-01-01',
    idNumber: '',
    altContact: '454 726-0592',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("KYC Data Submitted:", formData);
    // Success simulation
    alert("KYC data submitted successfully! Under review.");
  };

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">
      
      {/* Decorative Blur Background */}
      <img
        src={blurTop}
        alt="Decorative background blur"
        className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-50 max-h-48 object-cover"
      />

      {/* Content Area */}
      <div className="relative z-10 w-full max-w-sm mx-auto">
        
        {/* Illustration */}
            <div className="flex-1 flex justify-center items-center mt-4">
          <img
            src={kyc}
            alt=""
            className="w-full max-w-xs max-h-[45vh] object-contain"
          />
        </div>

        {/* Header Text */}
        <h1 className="text-3xl font-bold text-gray-900 mt-2">Let's verify KYC</h1>
        
        <p className="text-gray-600 text-sm mt-1 mb-8">
          Please submit the following documents verify your profile.
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>

          {/* Full Name Input */}
          <div>
            <label htmlFor="fullName" className="text-gray-700 text-base font-medium block mb-1">
              Full name
            </label>
            <input
              id="fullName"
              name="fullName"
              type="text"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400 shadow-inner"
              required
            />
          </div>

          {/* Date of Birth Input (Email placeholder in image seems to be a mistake, using DOB) */}
          <div>
            <label htmlFor="dateOfBirth" className="text-gray-700 text-base font-medium block mb-1">
              Date of birth
            </label>
            <input
              id="dateOfBirth"
              name="dateOfBirth"
              type="date" // Using date input for better mobile experience
              value={formData.dateOfBirth}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400 shadow-inner"
              required
            />
          </div>

          {/* ID Number Input */}
          <div>
            <label htmlFor="idNumber" className="text-gray-700 text-base font-medium block mb-1">
              ID number
            </label>
            <input
              id="idNumber"
              name="idNumber"
              type="text"
              placeholder="e.g., A1234567"
              value={formData.idNumber}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400 shadow-inner"
              required
            />
          </div>

          {/* Alternative Contact Input (Styling to match the image's flag/input container) */}
          <div>
            <label htmlFor="altContact" className="text-gray-700 text-base font-medium block mb-1">
              Alternative contact
            </label>
            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-xl px-4 py-3 space-x-3 shadow-inner">
              <span className="text-lg">🇨🇦</span> {/* Placeholder Flag/Country Code */}
              <input
                id="altContact"
                name="altContact"
                type="tel"
                placeholder="(454) 726-0592"
                value={formData.altContact}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800 placeholder:text-gray-400"
                required
              />
            </div>
          </div>

          {/* Submit Button (Large arrow icon) */}
          <button 
            type="submit" onClick={()=>{
            navigate('/kycaddress')
            }}
            className="w-full bg-blue-600 py-4 rounded-xl text-white mt-10 shadow-xl hover:bg-blue-700 transition-colors flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h14.755l-2.61-3.66a.75.75 0 111.19-1.045l4 5.625a.75.75 0 010 .91l-4 5.625a.75.75 0 11-1.19-1.045l2.61-3.66H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
}